import type { GeneratorOptions, Schema } from '@cli-types/core-engine/schema.js'
import type { CreatePageGeneratorResult } from '@cli-types/next-adapter/generators.js'
import { createGeneratedFile } from '@cli-utils/files.js'
import { singularize, singularizeLabel, toKebabCase, toPascalCase } from '@cli-utils/text.js'
import { renderCreatePageImportsTemplate } from '@next-adapter/templates/renderers/generators/create-page.js'

export function generateCreatePage(
  schema: Schema,
  pagesDir: string,
  _options: GeneratorOptions = {}
): CreatePageGeneratorResult {
  const singular = singularize(schema.name)
  const Singular = toPascalCase(singular)
  const singLabel = singularizeLabel(schema.label)
  const kebabName = toKebabCase(schema.name)

  const content = renderCreatePageImportsTemplate({
    singular: Singular,
    kebabName: kebabName,
    singLabel: singLabel
  })

  return {
    files: [createGeneratedFile(`${pagesDir}/${schema.name}/new/page.tsx`, content)]
  }
}
